import React, { useState } from 'react';
import { Plus } from 'lucide-react';

const faqs = [
  {
    question: 'Quanto custa uma avaliação imobiliária certificada?',
    answer: 'O valor varia consoante a tipologia, localização e complexidade do imóvel. Na Valuare JR, enviamos um orçamento rigoroso e sem compromisso em 24 horas, garantindo um preço justo pelo rigor técnico exigido.'
  },
  {
    question: 'Porquê escolher um Perito Certificado pela CMVM?',
    answer: 'O registo na CMVM é obrigatório nas avaliações destinadas a bancos, fundos de investimento e seguradoras. Nas restantes finalidades, como partilhas, heranças, divórcios e processos judiciais, não é legalmente exigido, mas é a garantia mais objetiva de que o perito tem qualificação, experiência e seguro de responsabilidade civil, e de que a avaliação segue as Normas Europeias de Avaliação.'
  },
  {
    question: 'Qual a diferença entre o Valor das Finanças (VPT) e o Valor de Mercado?',
    answer: 'O Valor Patrimonial Tributário (VPT) das Finanças serve apenas para o cálculo de impostos e está, na maioria das vezes, desatualizado. O Valor de Mercado reflete o valor real de transação do imóvel à data de hoje, sendo o único valor fiável para partilhas, heranças ou vendas justas.'
  },
  {
    question: 'Quanto tempo demora todo o processo?',
    answer: 'Após a aprovação do orçamento e a visita presencial ao imóvel para vistoria técnica, entregamos o relatório oficial assinado digitalmente num prazo de 5 a 8 dias úteis.'
  },
  {
    question: 'Quantas avaliações já realizou a Valuare JR?',
    answer: 'A Valuare JR já realizou mais de 500 avaliações imobiliárias, em 11 distritos.'
  }
];

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="vjr-faq-section" id="faq" data-testid="faq-section">
      <div className="vjr-faq-inner">
        <div className="vjr-faq-intro">
          <div className="valuare-section-label">Esclarecimentos</div>
          <h2 className="valuare-section-title">
            Perguntas<br /><em>Frequentes</em>
          </h2>
          <p className="vjr-faq-note">
            Não encontrou a resposta que procura?{' '}
            <a href="#contacto" data-testid="faq-contact-link">Fale connosco</a> — respondemos em 24 horas.
          </p>
        </div>
        <div className="vjr-faq-list">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.question} className={`vjr-faq-item ${isOpen ? 'open' : ''}`}>
                <button
                  className="vjr-faq-question"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  data-testid={`faq-question-${index}`}
                >
                  <span>{faq.question}</span>
                  <span className="vjr-faq-icon"><Plus /></span>
                </button>
                <div className="vjr-faq-answer">
                  <div className="vjr-faq-answer-inner">
                    <p data-testid={`faq-answer-${index}`}>{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
